import approvalMdl from "./approval.mdl";

export default [...approvalMdl];
